import React from 'react';

const MapClickConfirm = (props) => {
     
  return (
    <calcite-modal
    active   
    color=""
    background-color="white"
    scale="m"
    width="s"
    intl-close="Close"
    aria-describedby="modal-describedby"
    aria-labelledby="modal-labelledby"
    aria-modal="true"
    role="dialog"
    disable-close-button
  >
    <h3 slot="header" >
      Selections have changed !
    </h3>
    <div slot="content">
      <p style={{color: '#000'}}>
        You have made changes to your comparisons that have not yet been applied. Click "Compare" to ensure that your changes have been applied to the maps and charts.
      </p>
    </div>
    
    <calcite-button
      slot="primary"
      width="full"
      alignment="center"
      appearance="solid"
      color="blue"
      scale="m"
      onClick={props.okHandler}
    >
      OK
    </calcite-button>
  </calcite-modal>
  
  );
  
}

export default MapClickConfirm;
